import { Tooltip, Link, Typography } from "@material-ui/core";
import {
  UrlStatus,
  AdminSourceResponse,
  IdProvider,
} from "@authory-packages/core";
import { StatFieldset, FieldSetWrapper } from "../../styles";

type SourceStatsProps = {
  source: AdminSourceResponse;
};

const getSearchTerm = (source: AdminSourceResponse) => {
  return source.rootId
    ? IdProvider.toRootId(source.rootId)
    : IdProvider.toWebsiteId(source.id);
};

export const SourceStats = ({ source }: SourceStatsProps) => {
  const statFieldSet = StatFieldset();
  const fieldSetWrapper = FieldSetWrapper();

  return (
    <div className={fieldSetWrapper.root} style={{ marginLeft: 5 }}>
      <fieldset className={statFieldSet.root}>
        <Tooltip title="Found">
          <legend>Fnd</legend>
        </Tooltip>
        <Link
          href={`/urls?mainSearch=${getSearchTerm(source)}`}
          target="_blank"
        >
          <Typography color="textSecondary">{source.urlCount}</Typography>
        </Link>
      </fieldset>
      <fieldset className={statFieldSet.root}>
        <Tooltip title="Processing">
          <legend>Proc</legend>
        </Tooltip>
        <Link
          href={`/urls?mainSearch=${getSearchTerm(source)}&status=${
            UrlStatus.Processing
          }`}
          target="_blank"
        >
          <Typography color="textSecondary">
            {source.urlCount -
              source.countsPerStatus.PermanentError -
              source.countsPerStatus.Accepted -
              source.countsPerStatus.Rejected}
          </Typography>
        </Link>
      </fieldset>
      <fieldset className={statFieldSet.root}>
        <Tooltip title="Accepted">
          <legend>Acc</legend>
        </Tooltip>
        <Link
          href={`/urls?mainSearch=${getSearchTerm(source)}&status=${
            UrlStatus.Accepted
          }`}
          target="_blank"
        >
          <Typography color="textSecondary">
            {source.countsPerStatus.Accepted}
          </Typography>
        </Link>
      </fieldset>
      <fieldset className={statFieldSet.root}>
        <Tooltip title="Rejected">
          <legend>Rej</legend>
        </Tooltip>
        <Link
          href={`/urls?mainSearch=${getSearchTerm(source)}&status=${
            UrlStatus.Rejected
          }`}
          target="_blank"
        >
          <Typography color="textSecondary">
            {source.countsPerStatus.Rejected}
          </Typography>
        </Link>
      </fieldset>
      <fieldset className={statFieldSet.root}>
        <Tooltip title="Error">
          <legend>Err</legend>
        </Tooltip>
        <Link
          href={`/urls?mainSearch=${getSearchTerm(source)}&status=${
            UrlStatus.PermanentError
          }`}
          target="_blank"
        >
          <Typography color="textSecondary">
            {source.countsPerStatus.PermanentError}
          </Typography>
        </Link>
      </fieldset>
      <fieldset className={statFieldSet.root} style={{ minWidth: 80 }}>
        <Tooltip title="Number of articles">
          <legend>Nº Art</legend>
        </Tooltip>
        <Link
          href={`/urls?mainSearch=${IdProvider.toWebsiteId(source.id)}`}
          target="_blank"
        >
          <Typography color="textSecondary">
            {source.associatedArticleCount}
          </Typography>
        </Link>
      </fieldset>
      <fieldset className={statFieldSet.root}>
        <legend>Status</legend>
        <Tooltip title={source.executionError}>
          <Typography color="textSecondary">{source.status}</Typography>
        </Tooltip>
      </fieldset>
    </div>
  );
};
